import React from 'react';
import {formatData} from "../../js/shared-functions";

export default class DpcElencoCardImage extends React.Component {

    getText(text){
        if(!text || typeof text !== "string")
            return "";

        const regex = /(( ?)<\/?(?:a)[^>]*>)|<[^>]+>( ?)/ig;
        const subst = `$1`;
        const body = text.replace(regex, subst);

        if(body.length <= 140)
            return body;
        const subString = body.substr(0, 139);
        return subString.substr(0, subString.lastIndexOf(" ")) + "...";
    }

    render(){
        return (
            <article className="card-wrapper has-card-img">
                <div className="card">
                    <div className="row">
                        <div className="col-12 col-md-auto">
                            <a href={this.props.slug}>
                                <img
                                    src={this.props.image?.localFile?.publicURL}
                                    className="card-img" alt={this.props.altImage}/>
                            </a>
                        </div>
                        <div className="col-12 col-md">
                            <div className="card-body">
                                <div className="category-top">
                                    <span
                                        className="category">{this.props.categoria ? this.props.categoria?.replace('_', ' ') : ''}</span>
                                    <span
                                        className="data">{formatData(this.props.data_creazione, this.props.dataFormat)}</span>
                                </div>
                                <h2 className="h5 card-title">
                                    <a href={this.props.slug}>{this.props.title}</a>
                                </h2>
                                <div className="card-text"
                                     dangerouslySetInnerHTML={{__html: this.getText(this.props.body)}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        );
    }

}
